export const globals = {}; // a dispatch property is added to this in App.jsx so we can access it in apiAccess.js
